export const SET_ACCESSES = 'SET_ACCESSES';
export const SET_ACCESS = 'SET_ACCESS';
export const ADD_ACCESS = 'ADD_ACCESS';
export const UPDATE_ACCESS = 'UPDATE_ACCESS';
export const REMOVE_ACCESS = 'REMOVE_ACCESS';
export const CLEAR_ACCESS = 'CLEAR_ACCESS';
export const CLEAR_ACCESSES = 'CLEAR_ACCESSES';
